import { PanelLayout } from '@cbridge-tools/resizable-panels';

/**
 * Value of a `{page}.layout.{group}` setting: one layout per set of mounted panel ids
 * (a group with a conditional details panel has two sets). Keys are the sorted panel ids joined by ','.
 */
export type IPanelLayoutSetting = Record<string, PanelLayout>;

export type TPanelLayoutGroup = 'nav' | 'details' | 'page' | 'side' | 'content' | 'charts';

const SIZE_TOLERANCE = 0.01;

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null && !Array.isArray(value);

const isPanelLayout = (value: unknown): value is PanelLayout =>
  isRecord(value) && Object.values(value).every((size) => typeof size === 'number' && Number.isFinite(size));

export const isPanelLayoutSetting = (value: unknown): value is IPanelLayoutSetting =>
  isRecord(value) && Object.values(value).every(isPanelLayout);

export const panelLayoutSettingKey = (page: string, group: TPanelLayoutGroup): string => `${page}.layout.${group}`;

export const panelSetKey = (layout: PanelLayout): string => Object.keys(layout).sort().join(',');

export const isSamePanelLayout = (a: PanelLayout, b: PanelLayout): boolean => {
  const ids = Object.keys(a);

  return ids.length === Object.keys(b).length
    && ids.every((id) => id in b && Math.abs(a[id]! - b[id]!) <= SIZE_TOLERANCE);
};
